<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <b-alert :variant="alert.type"
          dismissible
          fade
          :show="alert.show"
          @dismissed="alert.show=false"
        >{{ alert.message }}</b-alert>
        <b-modal
          v-model="pendingChanges"
          size="sm"
          centered
          hide-footer
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          dismissible
        >
          <div class="modal-body">
            <div class="text-center justify-content-between">Bitte Warten</div>
            <div class="row"></div>
            <div class="text-center justify-content-between">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </div>
        </b-modal>
        <div class="card rounded-bottom-0">
          <div class="card-header">
            <h4 class="float-left">Ausschussware</h4>
            <button
              type="button"
              class="btn btn-md btn-secondary ml-2 float-right"
              :disabled="(selectedTemplate == null)"
              @click="() => { modalTemplateSelect.open() }"
            >
              <span class="icon icon-pencil"/>
            </button>
            <b-form-select
              v-if="renderComponentHack == true"
              class="float-right col-md-4"
              id="sctTemplate"
              :options="templates"
              v-model="selectedTemplate"
            ></b-form-select>
            <button
              type="button"
              class="btn btn-secondary btn-md mx-2 float-right"
              @click="modalTemplateCreate.createNewTemplate()"
            >
              <span class="icon icon-plus"/>
            </button>
          </div>
          <div class="card-body px-1">
            <span v-if="modalTemplateSelect.selection != null">Template "{{modalTemplateSelect.selection.name}}" wurde ausgewaehlt.</span>
            <h5 class="ml-auto pl-3">Material Liste</h5>
            <div class="col-md-12">
              <b-textarea
                class="form-control"
                name="whiteListTextArea"
                rows="3"
                v-model="materialIdList"
              />
              <button
                type="button"
                class="btn btn-primary ml-2 mt-3 float-right"
                :disabled="selectedTemplate == null"
                @click="applyCustomItemNote()"
              >
                <span v-if="selectedTemplate != null">Anwenden</span>
                <span v-else class="icon icon-minus"/>
              </button>
            </div>
          </div>
        </div>
        <modal-error-component v-model="modalError"></modal-error-component>
        <b-modal 
          v-model="modalTemplateCreate.state"
          centered
          size="xl"
          title="Template Übersetzung hinzufügen"
          @ok="modalTemplateCreate.storeNewTemplate()"  
          @hidden="modalTemplateCreate.abort()"
        >
          <b-textarea v-model="modalTemplateCreate.template.name"/>
        </b-modal>
        <b-modal 
          v-model="modalTemplateSelect.state"
          title="Template"
          centered
          size="xl"
          @hidden="modalTemplateSelect.abort()"
          @ok="modalTemplateSelect.saveTranslation()"
        >
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="card border-bottom-0 rounded-bottom-0">
                  <div class="card-header border-bottom-0">
                    <h4 class="float-left">{{templates[selectedTemplate] }}</h4>
                    <button
                      type="button"
                      class="btn btn-secondary btn-md mx-2 float-right"
                      :disabled="(modalTemplateSelect.selectedCountry == null) || (modalTemplateSelect.selectedTranslation.countryId != null)"
                      @click="modalTemplateSelect.createTranslation()"
                    >
                      <span class="icon icon-plus"></span>
                    </button>
                    <b-form-select
                      class="float-right col-md-4"
                      id="sctTemplate"
                      :disabled="modalTemplateSelect.selectedTranslation.countryId != null"
                      :options="modalTemplateSelect.remainingCountries"
                      v-model="modalTemplateSelect.selectedCountry"
                    ></b-form-select>
                  </div>
                </div>

                <table v-if="translations != null" class="table">
                  <thead>
                    <tr>
                      <th scope="col">Land</th>
                      <th scope="col">translation</th>
                      <th scope="col" style="width: 125px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="itr in translations" v-bind:key="itr.countryId">
                      <td>{{countries[itr.countryId]}}</td>
                      <td v-if="modalTemplateSelect.selectedTranslation.id !== itr.id">{{itr.itemNote}}</td>
                      <td v-else>
                        <b-textarea
                          v-model="modalTemplateSelect.selectedTranslation.itemNote"
                          style="min-width: 100%"
                        ></b-textarea>
                      </td>
                      <td v-if="modalTemplateSelect.selectedTranslation.id !== itr.id">
                        <button
                          type="button"
                          class="btn btn-primary btn-md mx-1 float-right"
                          :disabled="modalTemplateSelect.selectedTranslation.id != null || (modalTemplateSelect.selectedTranslation.countryId != null)"
                          @click="modalTemplateSelect.editTranslation(itr)"
                        >
                          <span class="icon icon-pencil"></span>
                        </button>
                      </td>
                      <td v-else>
                        <button
                          type="button"
                          class="btn btn-primary btn-md mx-1 float-right"
                          @click="modalTemplateSelect.saveTranslation()"
                        >
                          <span class="icon icon-checkmark"></span>
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary btn-md float-right"
                          @click="modalTemplateSelect.abortTranslation()"
                        >
                          <span class="icon icon-cross"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div slot="modal-footer" class="w-100">
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script> export default {
  props: [ "passedTemplateMap", "passedCountryMap"],
  data () { 
    return {
      pendingChanges: false,
      renderComponentHack: true,
      selectedTemplate: null,
      countries: this.passedCountryMap,
      templates: this.passedTemplateMap,
      translations: null,
      materialIdList: "",
      alert: {
        show: false,
        message: null,
        type: null,
      },
      modalError: {
        show: false,
        message: 'unpopulated', 
        error: 'unpopulated', 
        title: 'unpopulated'
      },
      applyCustomItemNote: () => {
        // sanityCheck materialIds
        this.pendingChanges = true;
        var payload = {
            id: this.selectedTemplate,
            materialIds: this.materialIdList
          };
        axios.post('/customitemnote/apply', payload)
        .then((response) => {
          if(response.data.status == 200) {
            this.alert.show = true;
            this.alert.message = "Item Notes wurden erfolgreich übertragen.";
            this.alert.type = "success";
            this.pendingChanges = false;
            return;
          }
          this.modalError = {
            show: true,
            message: 'Ein Fehler ist aufgetreten',
            error: '',
            title: 'CustomItemNote Apply'
          };

        }).catch((err) => {
          this.modalError = {
            show: true,
            message: 'Das Template konnte nicht auf die Materials angewandt werden.',
            error: err,
            title: 'CustomItemNote Speichern'
          };
          this.alert.show = true;
          this.alert.message = 'Das Template konnte nicht auf die Materials angewandt werden.';
          this.alert.type = "danger";
          this.pendingChanges = false;

        });
      },
      modalTemplateCreate: {
        parent: this,
        state: false,
        template: {
          id: null,
          name: "",
        },
        createNewTemplate() {
          this.parent.selectedTemplate = this.template.name;
          this.template = {
            id: null, 
            name: "" 
          };
          this.state = true;
        },
        abort(){
          this.template = {
            id: null,
            name: ""
          }
        },
        storeNewTemplate() {
          axios.post('/customitemnote/store', this.template)
          .then((response) => {
            // add template
            this.parent.templates[response.data.id] = response.data.name;
            this.template = {
              id: null,
              name: ""
            }
            this.state = false;
            this.renderComponentHack = false;
            this.parent.$nextTick(() => {
              this.renderComponentHack = true;
              this.selectedTemplate = response.data.id;
              this.modalTemplateCreate.template = {
                id: null,
                name: ""
              }
              this.modalTemplateCreate.state = false;
              this.modalTemplateSelect.state = true;
              this.modalTemplateSelect.open();
            });
    
          }).catch( (err) => {
            this.modalError = {
              show: true,
              message: 'Das Template konnte nicht abgespeichert werden.',
              error: err,
              title: 'CustomItemNote Speichern'
            };
          });
        }
      },
      modalTemplateSelect: {
        parent: this,
        state: false,
        selection: null,
        remainingCountries: [],
        selectedCountry: null,
        selectedTranslation: {
          id: null,
          customItemNoteId: null,
          countryId: null,
          itemNote: null
        },
        open() {
          var dumpSelectedTemplate = this.parent.selectedTemplate;
          this.parent.translations = null;
          let url = '/customitemnote/template/translation/' + this.parent.selectedTemplate;
          axios.get(url)
          .then( (response) => {
            this.parent.translations = response.data;
            //sort by country name
            this.parent.translations.sort((v, w) => (this.parent.countries[v.countryId] > this.parent.countries[w.countryId]) ? 1 : -1)
            //calculate remaining countries. Somehow this works with filter...
            this.remainingCountries = [];
            var remainingCountryIds = _.difference(
              _.map(Object.keys(this.parent.countries), (w) => { return parseInt(w) }), // countryIds of all countries
              _.map(this.parent.translations, (t) => {return t.countryId })  // countryIds of all existing translations
            );
            for(let k = 0; k < remainingCountryIds.length; ++k) {
              this.remainingCountries[remainingCountryIds[k]] = this.parent.countries[remainingCountryIds[k]];
            }
            this.state = true;
            this.parent.$nextTick(() => {
              this.parent.selectedTemplate = dumpSelectedTemplate;
            });
          })
          .catch( err => {
              this.parent.modalError = {
              show: true,
              message: 'Das Template konnte nicht abgespeichert werden.',
              error: err,
              title: 'saveTranslation'
            };
        
          });
        },
        abort(resetTemplate) {
          this.selectedCountry = null;
          this.selectedTranslation = {
            id: null,
            customItemNoteId: null,
            countryId: null,
            itemNote: null
          }
          if(resetTemplate) {
            this.parent.selectedTemplate = null
          }
        },
        abortTranslation() {
          this.selectedTranslation = {
            id: null,
            customItemNoteId: null,
            countryId: null,
            itemNote: null  
          }
          this.open();
        },
        createTranslation() {
          var newTranslation = {
            id: null,
            customItemNoteId: this.parent.selectedTemplate,
            countryId: _.invert(this.parent.countries)[this.selectedCountry],
            itemNote: ""
          };
          this.parent.translations.unshift(newTranslation);
          this.parent.translations.sort((v, w) => (this.parent.countries[v.countryId] > this.parent.countries[w.countryId]) ? 1 : -1)

          this.selectedTranslation = newTranslation;
        },
        saveTranslation() {
          var url = "";
          if(this.selectedTranslation.id == null)
          {
            url ="/customitemnote/template/translation/store";
          }
          else
          {
            url ="/customitemnote/template/translation/" + this.selectedTranslation.id + "/update";
          }
          axios.post(url, this.selectedTranslation)
          .then((response) => {
            if(response.data.status == 200) {
              this.selectedTranslation = {
                id: null,
                customItemNoteId: null,
                countryId: null,
                itemNote: null  
              }
              this.open();
              return;
            }
            this.parent.modalError = {
              show: true,
              message: 'Das Template konnte nicht abgespeichert werden.',
              error: '',
              title: 'saveTranslation'
            };
          }).catch((err) => {
              this.parent.modalError = {
              show: true,
              message: 'Das Template konnte nicht abgespeichert werden.',
              error: err,
              title: 'saveTranslation'
            };
          });
        },
        editTranslation(translation) {
          this.selectedTranslation = translation;
        }
      }
    }
  }
}
</script>
